import { render, staticRenderFns } from "./middle-dialog.vue?vue&type=template&id=2085c680"
import script from "./middle-dialog.vue?vue&type=script&lang=js"
export * from "./middle-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports